import { format } from 'date-fns'
import { useAuthStore } from '@/stores/auth'
import { useGet } from './useFetch'
import { ApiResponse, SupplierTrendDataPoint } from '@magnetar/admin-api-interfaces'

interface UseSupplierTrendStatsParams {
  supplierId: number
  startDate?: Date
  endDate?: Date
  granularity?: 'daily' | 'weekly' | 'monthly'
  clinicId?: number
  adId?: number
}

export const useSupplierTrendStats = ({
  supplierId,
  startDate,
  endDate,
  granularity = 'daily',
  clinicId,
  adId,
}: UseSupplierTrendStatsParams) => {
  const { token } = useAuthStore()

  const queryParams = new URLSearchParams()
  if (startDate) {
    queryParams.append('startDate', format(startDate, 'yyyy-MM-dd'))
  }
  if (endDate) {
    queryParams.append('endDate', format(endDate, 'yyyy-MM-dd'))
  }
  queryParams.append('granularity', granularity)
  if (clinicId) {
    queryParams.append('clinicId', String(clinicId))
  }
  if (adId) {
    queryParams.append('adId', String(adId))
  }

  const url = `/api/ad-suppliers/${supplierId}/report/trend?${queryParams.toString()}`

  const {
    data,
    error,
    isLoading,
    mutate,
  } = useGet<ApiResponse<SupplierTrendDataPoint[]>>(
    token && supplierId ? url : null,
    undefined,
    token ?? '',
  )

  return {
    trendData: data?.data ?? [],
    isLoading,
    isError: error,
    mutate,
  }
}
